import { useI18n } from '../state/I18nContext'
import { HeroSection }        from './home/HeroSection'
import { TrustStrip }         from './home/TrustStrip'
import { AnimSection }        from './home/AnimSection'
import { HistoriaSection }    from './home/HistoriaSection'
import { ProductsSection }    from './home/ProductsSection'
import { LifestyleStrip }     from './home/LifestyleStrip'
import { EnviosSection }      from './home/EnviosSection'
import { ProcessoSection }    from './home/ProcessoSection'
import { TestemunhosSection } from './home/TestemunhosSection'
import { FaqSection }         from './home/FaqSection'
import { CtaSection }         from './home/CtaSection'

const Home: React.FC = () => {
  const { t, locale } = useI18n()
  const l = t.landing
  const home = `/${locale}/`

  return (
    <>
      <HeroSection        l={l} home={home} />
      <TrustStrip         items={l.strip} />
      <AnimSection        l={l.animSection} />
      <HistoriaSection    l={l.historia} />
      <ProductsSection    locale={locale} l={l} t={t} />
      <LifestyleStrip     l={l.lifestyle} />
      <EnviosSection      l={l.shipping} />
      <ProcessoSection    l={l.processo} />
      <TestemunhosSection l={l.testemunhos} />
      <FaqSection         l={l.faq} />
      <CtaSection         l={l.cta} home={home} />
    </>
  )
}

export default Home

